// store
import { defineStore } from "pinia";
// types
import {
  DailyTask,
  DailyTaskCompleteInfo,
  TaskCompleteInfo,
  WeeklyTask,
  WeeklyTaskCompleteInfo
} from "@/@types/Task";
import { fixTodayString, getToday, getNearestDay } from "@/utils/CommonUtils";

const MAINTENANCE_DAY_OF_WEEK = 3;
const dailyTask = {
  leahMaysTask: {
    no: 0,
    id: "leahMaysTask",
    dateLineHour: 4,
  } as DailyTask,
  alphaReactor: {
    no: 1,
    id: "alphaReactor",
    dateLineHour: 4,
  } as DailyTask,
  stellarSeed: {
    no: 2,
    id: "stellarSeed",
    dateLineHour: 4,
  } as DailyTask,
  photonScale: {
    no: 3,
    id: "photonScale",
    dateLineHour: 4,
  } as DailyTask,
  likeCoordinateCatalog: {
    no: 4,
    id: "likeCoordinateCatalog",
    dateLineHour: 0,
  } as DailyTask,
} as const;
export const dailyTaskList: DailyTask[] = [
  dailyTask.leahMaysTask, dailyTask.alphaReactor, dailyTask.stellarSeed, dailyTask.photonScale, dailyTask.likeCoordinateCatalog
];

const weeklyTask = {
  casinoPrizeSg: {
    id: "casinoPrizeSg",
    dateLineHour: 13,
    weekLineDow: MAINTENANCE_DAY_OF_WEEK,
  } as WeeklyTask,
} as const;
export const weeklyTaskList: WeeklyTask[] = [
  weeklyTask.casinoPrizeSg
];

const compareTask = (a: TaskCompleteInfo, b: TaskCompleteInfo) => {
  if (a.no === b.no) return 0;
  if (a.no < b.no) {
    return -1;
  } else {
    return 1;
  }
};

export const useTaskStore = defineStore("task", {
  state: () => ({
    ready: false,
    dailyTaskCompleteInfo: [] as DailyTaskCompleteInfo[],
    weeklyTaskCompleteInfo: [] as WeeklyTaskCompleteInfo[],
  }),
  getters: {
  },
  actions: {
    init() {
      if (this.dailyTaskCompleteInfo.length > 0) {
        dailyTaskList.forEach(task => {
          const userTask = this.dailyTaskCompleteInfo.find(ci => ci.id === task.id);
          if (!userTask) {
            this.dailyTaskCompleteInfo.push({
              id: task.id,
              no: task.no,
              dateLineHour: task.dateLineHour,
              completed: false,
              completeAt: ""
            });
          } else {
            const completeDate = new Date(fixTodayString(userTask.completeAt));
            const today = getToday(task.dateLineHour);
            if (completeDate < today) {
              userTask.completed = false;
            }
          }
        });
      } else {
        dailyTaskList.forEach(task => {
          this.dailyTaskCompleteInfo.push({
            id: task.id,
            no: task.no,
            dateLineHour: task.dateLineHour,
            completed: false,
            completeAt: ""
          });
        });
      }
      const copyDaily = [...this.dailyTaskCompleteInfo];
      copyDaily.sort(compareTask);
      this.dailyTaskCompleteInfo.splice(0);
      this.dailyTaskCompleteInfo.push(...copyDaily);
      if (this.weeklyTaskCompleteInfo.length > 0) {
        weeklyTaskList.forEach(task => {
          const userTask = this.weeklyTaskCompleteInfo.find(ci => ci.id === task.id);
          if (!userTask) {
            this.weeklyTaskCompleteInfo.push({
              id: task.id,
              no: task.no,
              dateLineHour: task.dateLineHour,
              weekLineDow: task.weekLineDow,
              completed: false,
              completeAt: ""
            });
          } else {
            const completeDay = new Date(fixTodayString(userTask.completeAt));
            const today = getToday(task.dateLineHour);
            if (completeDay < today) {
              const nearestDay = getNearestDay(task.dateLineHour, task.weekLineDow);
              if (nearestDay > completeDay) {
                userTask.completed = false;
              }
            }
          }
        });
      } else {
        weeklyTaskList.forEach(task => {
          this.weeklyTaskCompleteInfo.push({
            id: task.id,
            no: task.no,
            dateLineHour: task.dateLineHour,
            weekLineDow: task.weekLineDow,
            completed: false,
            completeAt: ""
          });
        });
      }
      const copyWeekly = [...this.weeklyTaskCompleteInfo];
      copyWeekly.sort(compareTask);
      this.weeklyTaskCompleteInfo.splice(0);
      this.weeklyTaskCompleteInfo.push(...copyWeekly);
      this.ready = true;
    },
    updateDaily(id: string, completed: boolean, completeAt: string) {
      const index = this.dailyTaskCompleteInfo.findIndex(ci => ci.id === id);
      if (index >= 0) {
        this.dailyTaskCompleteInfo[index].completed = completed;
        this.dailyTaskCompleteInfo[index].completeAt = completeAt;
      }
    },
    updateWeekly(id: string, completed: boolean, completeAt: string) {
      const index = this.weeklyTaskCompleteInfo.findIndex(ci => ci.id === id);
      if (index >= 0) {
        this.weeklyTaskCompleteInfo[index].completed = completed;
        this.weeklyTaskCompleteInfo[index].completeAt = completeAt;
      }
    },
  },
  persist: {
    enabled: true,
    strategies: [{ storage: localStorage }],
  },
});
